import React from 'react';

const Logo = ({ className = "", size = 40 }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_dream-house-preview-1/artifacts/u9hldk85_Copilot_20260615_155431.png"
      alt="Dream House Canada"
      width={size}
      height={size}
      className={`rounded-full ${className}`}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default Logo;
